/**
 * The bulk upload endpoints split `chatDocumentIds` on commas; a JSON array makes
 * their validator throw (HTTP 500), so the ids go over the wire comma-joined.
 */
export const serializeChatDocumentIds = (chatDocumentIds: string[]): string => chatDocumentIds.join(',');
